module.exports = __webpack_public_path__ + "media/images/ai_voice_samples/rohan-c321b36b211a9de27f46a9333acc4b8d.mp3";